module.exports = __webpack_public_path__ + "static/media/email.dc3123cf.svg";